import icone from '../../assets/images/Rectangle.png';
import icone2 from '../../assets/images/Icon.png';
import infoIcon from '../../assets/images/info.png';
import heartIcon from '../../assets/images/coeur.png';
import { FaEllipsisV, FaFolderOpen, FaEdit, FaDownload } from 'react-icons/fa';
import api from '../../service/caller';
import { ToastContainer, toast } from 'react-toastify';
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    CButton,
    CRow,
    CCol,
    CCard,
    CCardBody,
    CTab,
    CTabContent,
    CTabList,
    CTabPanel,
    CTabs,
    CHeader, CContainer, CHeaderNav, CNavItem, CNavLink,
    CTable,
    CTableBody,
    CTableDataCell,
    CTableHead,
    CTableHeaderCell,
    CTableRow,
    CModal,
    CModalHeader,
    CModalTitle,
    CModalBody,
    CModalFooter,
    CPagination,
    CPaginationItem
} from '@coreui/react';

const NurseDashboard = () => {
    const navigate = useNavigate();
    const [UserData, setUserData] = useState([]);
    const [appointments, setAppointments] = useState([]);
    const [filteredAppointments, setFilteredAppointments] = useState([]);
    const [departments, setDepartments] = useState([]);
    const [patients, setPatients] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(5);
    const popoverRefs = useRef([]);

    // Reset page when patients change
    useEffect(() => {
        setCurrentPage(1);
    }, [patients]);

    // Fetch logged user data
    useEffect(() => {
        const fetchLoggedUserData = async () => {
            try {
                const response = await api.get('api/usersprofile');
                setUserData(response.data);
            } catch (error) {
                toast.error("Failed to fetch data");
            }
        };
        fetchLoggedUserData();
    }, []);

    // Fetch appointments
    useEffect(() => {
        const fetchAppointments = async () => {
            try {
                const token = localStorage.getItem('access_token');
                if (!token) throw new Error('Token not found');
                
                const response = await api.get('/clinic/allbilling');
                const billingsData = response.data;
                
                setAppointments(billingsData);
                
                if (UserData?.hospital_id) {
                    const userHospitalIds = UserData.hospital_id.map(hospital => hospital._id);
                    const filtered = billingsData.filter(appointment => 
                        userHospitalIds.includes(appointment?.hospitalId)
                    );
                    setFilteredAppointments(filtered);
                }
            } catch (error) {
                console.error('Error fetching appointments:', error);
                toast.error("Failed to fetch appointments");
            }
        };

        if (UserData && UserData.hospital_id) {
            fetchAppointments();
        }
    }, [UserData]);

    // Fetch patients
    const fetchPatients = async (hospitalIds) => {
        if (!hospitalIds || hospitalIds.length === 0) {
            console.error("Erreur: hospitalIds est vide ou non disponible");
            return;
        }
        try {
            const response = await api.get(`/clinic/patients`, {
                params: { hospitalIds }
            });
            setPatients(response.data.patients);
        } catch (error) {
            console.error('Erreur lors de la récupération des patients:', error);
            toast.error("Failed to fetch patients");
        }
    };

    useEffect(() => {
        if (UserData && UserData.hospital_id && Array.isArray(UserData.hospital_id) && UserData.hospital_id.length > 0) {
            const hospitalIds = UserData.hospital_id;
            fetchPatients(hospitalIds);
        } else {
            console.error("UserData ou hospital_id non disponible pour fetchPatients");
        }
    }, [UserData]);

    // Fetch departments
    useEffect(() => {
        const fetchDepartments = async () => {
            try {
                const response = await api.get(`/api/departments`, {
                    headers: {
                        'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
                    }
                });
                setDepartments(response.data.data);
            } catch (error) {
                console.error('Error fetching departments:', error);
            }
        };
        fetchDepartments();
    }, []);

    // Initialize popovers
    useEffect(() => {
        popoverRefs.current.forEach((popoverEl) => {
            if (popoverEl && window.bootstrap) {
                new window.bootstrap.Popover(popoverEl, {
                    html: true,
                    trigger: 'click',
                });
            }
        });
    }, [appointments]);

    // Navigation handlers
    const handleViewHistory = () => {
        navigate("/hospitaladmin/appointment_history");
    };
    
    const handleviewcalendar = (doctorId) => {
        navigate(`/hospitaladmin/doctor/calendar/${doctorId}`);
    };

    // Pagination calculations
    const totalPages = Math.ceil(patients.length / itemsPerPage) || 1;
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = patients.slice(indexOfFirstItem, indexOfLastItem);

    // Page change handler
    const handlePageChange = (pageNumber) => {
        if (pageNumber < 1 || pageNumber > totalPages) return;
        setCurrentPage(pageNumber);
    };

    return (
        <div className='enrol'>
            <div className="py-4 doc" style={{ fontFamily: 'Arial, sans-serif' }}>
                <p className="text-primary">{new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
                <h2 className="text-primary fw-bold fs-1 mb-3" style={{color:"#0056b3"}}>Good morning, {UserData.firstname} {UserData.lastname}</h2>
                
                {/* Dashboard Cards */}
                <div className="row mb-4">
                    {/* Current Patient Count Card */}
                    <div className="col-md-4" style={{ borderRadius: "20px" }}>
                        <div className="card text-white mb-3 text-center" style={{ borderRadius: "20px" }} >
                            <div className="card-body" style={{
                                borderRadius: "20px", 
                                background: 'linear-gradient(180deg,rgb(73, 79, 75),rgb(77, 92, 77))'
                            }}>
                                <div className='d-flex justify-content-between'>
                                    <div>
                                        <h5 className="card-title text-start">Current patient count</h5>
                                        <p className="card-text display-4 text-start">{patients.length}</p>
                                    </div>
                                    <div className='text-end align-items-left'>
                                        <img src={icone2} alt="Icon" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Medications Due Now Card */}
                    <div className="col-md-4" style={{ borderRadius: "20px" }}>
                        <div className="card text-white mb-3 text-center" style={{ borderRadius: "20px" }}>
                            <div className="card-body" style={{ 
                                borderRadius: "20px", 
                                background: 'linear-gradient(180deg, #28A745, #4CAF50)' 
                            }}>
                                <div className='d-flex justify-content-between'>
                                    <div>
                                        <h5 className="card-title text-start">Medications Due Now</h5>
                                        <p className="card-text display-4 text-start">
                                            {filteredAppointments.filter(apt => apt.paymentstatus === false).length || 0}
                                        </p>
                                    </div>
                                    <div className='text-end align-items-left'>
                                        <img src={icone2} alt="Icon" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Tasks Due Today Card */}
                    <div className="col-md-4">
                        <div className="card text-white mb-3 text-center" style={{ borderRadius: "20px" }}>
                            <div className="card-body" style={{ 
                                borderRadius: "20px", 
                                background: 'linear-gradient(180deg, #FF9800, #FFC107)' 
                            }}>
                                <div className='d-flex justify-content-between'>
                                    <div>
                                        <h5 className="card-title text-start">Tasks Due Today</h5>
                                        <p className="card-text display-4 text-start">
                                            {filteredAppointments.filter(apt => apt.paymentstatus === true).length || 0}
                                        </p>
                                    </div>
                                    <div className='text-end align-items-left'>
                                        <img src={icone2} alt="Icon" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Patients Table Section */}
                <div className="row">
                    <div className="col-12 bg-white" style={{ borderRadius: "20px" }}>
                        <div className="card p-4">
                            <div className="card-body">
                                <div className="d-flex justify-content-between align-items-center mb-4">
                                    <h5 className='card-title fw-bold text-info' style={{color:"#0056b3"}}>Patients</h5>
                                </div>

                                {/* Patients Table */}
                                <div className='patientlisttable'>
                                    <CTable className="mt-5 ctable-no-border" align="middle" responsive>
                                        <CTableHead>
                                            <CTableRow className='tablehead'>
                                                <CTableHeaderCell scope="col">ID</CTableHeaderCell>
                                                <CTableHeaderCell scope="col">NAME</CTableHeaderCell>
                                                <CTableHeaderCell scope="col">ADDRESS</CTableHeaderCell>
                                                <CTableHeaderCell scope="col">LAST VISIT</CTableHeaderCell>
                                                <CTableHeaderCell scope="col">PHONE</CTableHeaderCell>
                                            </CTableRow>
                                        </CTableHead>
                                        <CTableBody>
                                            {currentItems.length > 0 ? (
                                                currentItems.map((patient) => (
                                                    <CTableRow className="ctable-row" key={patient._id}>
                                                        <CTableDataCell align="middle">{patient.patientId}</CTableDataCell>
                                                        <CTableDataCell>{patient.lastname} {patient.firstname}</CTableDataCell>
                                                        <CTableDataCell>{patient.address}</CTableDataCell>
                                                        <CTableDataCell>{patient.email}</CTableDataCell>
                                                        <CTableDataCell>{patient.phone}</CTableDataCell>
                                                    </CTableRow>
                                                ))
                                            ) : (
                                                <CTableRow>
                                                    <CTableDataCell colSpan="5" className="text-center">
                                                        No patient records found
                                                    </CTableDataCell>
                                                </CTableRow>
                                            )}
                                        </CTableBody>
                                    </CTable>
                                </div>

                                {/* Pagination Controls */}
                                <div className="d-flex justify-content-between align-items-center mt-4">
                                    <div>
                                        Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, patients.length)} of {patients.length} entries
                                    </div>
                                    <CPagination aria-label="Page navigation" className="mb-0">
                                        <CPaginationItem 
                                            onClick={() => handlePageChange(currentPage - 1)}
                                            disabled={currentPage === 1}
                                        >
                                            Previous
                                        </CPaginationItem>
                                        
                                        {[...Array(totalPages)].map((_, i) => (
                                            <CPaginationItem
                                                key={i + 1}
                                                active={i + 1 === currentPage}
                                                onClick={() => handlePageChange(i + 1)}
                                            >
                                                {i + 1}
                                            </CPaginationItem>
                                        ))}
                                        
                                        <CPaginationItem 
                                            onClick={() => handlePageChange(currentPage + 1)}
                                            disabled={currentPage === totalPages}
                                        >
                                            Next
                                        </CPaginationItem>
                                    </CPagination>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NurseDashboard;